import { combineReducers } from 'redux';
import auth from './auth/reducer';
import notificationCenter from './notificationCenter/reducer';
import loading from './loading/reducer';

export default combineReducers({
  auth,
  notificationCenter,
  loading,
});
